import { useContext, useEffect } from 'react';

import { Context } from '#src/lib/analytics/context.js';

// sets the orderId in the analytics context so header links (for example) can include it in their analytics events
export const useOrderAnalyticsContext = (orderId) => {
  const { setValue } = useContext(Context) || {};
  useEffect(() => {
    setValue?.({ orderId });
  }, [orderId, setValue]);
};
